import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {InventoryService} from '~/app/core/common/services/inventory.service';
import {OrderItemService} from '~/app/core/common/services/order-item.service';
import {ApplicationSettingsHelper} from '~/app/shared/helpers/application-settings-helper';
import {InventoryDetails} from '~/app/core/common/models/inventoryDetails';
import {InventoryHeader} from '~/app/core/common/models/inventoryHeader';
import {KendoGridHelperComponent} from '~/app/shared/helpers/kendo-grid-helper';
import {DialogHelperComponent} from '~/app/shared/helpers/dialog-helper';
import {RadlistviewHelperComponent} from '~/app/shared/helpers/radlistview-helper';
import {TextFieldHelperComponent} from '~/app/shared/helpers/text-field-helper';
import {Nomenclatures} from '../../core/common/enums/Nomenclatures';
import {LoadingIndicatorHelper} from '~/app/shared/helpers/loading-indicator-helper';
import {DeviceHelperComponent} from '~/app/shared/helpers/device-helper';
import {Router} from '@angular/router';
import {StoreListService} from '~/app/core/common/services/store-list.service';
import {InternetConnectionService} from '~/app/shared/services/internet-connection.service';
import {PartialdialogComponent} from '~/app/web/components/partialdialog/partialdialog.component';
import {encodeBase64, saveAs} from '@progress/kendo-file-saver';

interface OnDestory {
}

@Component({
    selector: 'app-inventory',
    templateUrl: './inventory.component.html',
    styleUrls: ['./inventory.component.scss']
})

export class InventoryComponent implements OnInit, AfterViewInit, OnDestory {

    Nomenclatures = Nomenclatures;
    initialized = false;
    totalReceiptError = false;
    salesTaxError = false;
    discountError = false;
    surchargeError = false;
    partialQtyError = false;
    partialPackSizeError = false;
    showPartial = false;
    showAddItem = false;
    gridData: any = null;
    state: any;
    headerInfo: InventoryHeader;
    inventoryGrid: ElementRef;
    columns: any[];
    partialQtyInput = '';
    partialPackSizeInput = '';
    partialCalcDecimal = '';
    hidePartial = false;
    partialStatus: boolean;
    private trackingId: any;

    constructor(public inventoryService: InventoryService,
                public orderItemService: OrderItemService,
                public storeListService: StoreListService,
                public kendoHelper: KendoGridHelperComponent,
                public textFieldHelper: TextFieldHelperComponent,
                public dialogHelper: DialogHelperComponent,
                public applicationSettingsHelper: ApplicationSettingsHelper,
                public deviceHelper: DeviceHelperComponent,
                public router: Router,
                public internetConnectionService: InternetConnectionService,
                private _loadingIndicatorHelper: LoadingIndicatorHelper,
                private _radListViewHelper: RadlistviewHelperComponent
    ) {
    }

    @ViewChild('inventoryGrid', {static: false}) set content(content: ElementRef) {
        this.inventoryGrid = content;
        this.kendoHelper.gridReference = this.inventoryGrid;
    }

    // Fix the issue with the columns not assigning
    private static assignColumns() {
        return [
            {
                field: 'customerItem',
                title: 'Item Number',
                width: '240',
                editable: false,
                filterable: true,
                colWidth: 160
            },
            {
                field: 'description',
                title: 'Description',
                width: '240',
                editable: false,
                filterable: true,
                colWidth: 160
            },
            {
                field: 'uomPackSize',
                title: 'Unit Of Measure',
                width: '150',
                editable: false,
                filterable: false,
                colWidth: 160
            },
            {
                field: 'qty', title: 'Quantity', width: '65', media: '(min-width: 768px)', editable: true,
                editor: 'numeric', colWidth: 60, format: '{0:n2}'
            },
            {
                field: 'price',
                title: 'Cost',
                width: '65',
                media: '(min-width: 768px)',
                editable: false,
                editor: 'numeric',
                colWidth: 60,
                format: '{0:c}',
                style: {'text-align': 'right'}
            },
            {
                field: 'amount',
                title: 'Amount',
                width: '150',
                editable: false,
                editor: 'numeric',
                media: '(min-width: 768px)',
                colWidth: 160,
                format: '{0:c}',
                style: {'text-align': 'right'}
            }];
    }

    removeCallBack = (args) => args.dataItem;

    async ngOnInit() {

        const options = {
            message: 'Loading...',
        };
        this.columns = InventoryComponent.assignColumns();
        this._loadingIndicatorHelper.show(options);

        const stringEvent = this.applicationSettingsHelper.getEvent();
        const event = JSON.parse(stringEvent);
        this.trackingId = event.trackingId;

        this.initialized = await this.initializeView();
        if (this.inventoryService.inventoryDetails == null) {
            console.log('No Data');
        }
        await this.kendoHelper.applyDocumentBind(this);
        this.state = this.kendoHelper.createStateForGrid();
        this.populateAllItemsListView();
        await this.kendoHelper.applyDocumentBind(this);
        this.state = this.kendoHelper.createStateForGrid();
        this.populateAllItemsListView();
        this._loadingIndicatorHelper.hide();
        if (this.deviceHelper.isTablet()) {
            this.deviceHelper.enableRotation();
        }


    }

    async initializeView(): Promise<boolean> {
        await this.inventoryService.getInventoryReceivingDetails(this.storeListService.pickedCustomerId,
            +this.applicationSettingsHelper.getEventStatus(), this.trackingId);
        await this.orderItemService.downloadAllItemsByStoreNumber(this.storeListService.pickedCustomerId.toString(), '-1');
        return true;
    }

    populateAllItemsListView() {
        this.gridData = this.kendoHelper.processItemsAndReturn(this.inventoryService.inventoryDetails.details, this.state);
        this.headerInfo = this.inventoryService.inventoryDetails.header;
        this.kendoHelper.restartStateCategory();
    }


    ngAfterViewInit(): void {
        this.kendoHelper.gridReference = this.inventoryGrid;
    }

    showPartialContainer() {
        this.showPartial = !this.showPartial;
        if (this.showPartial === false) {
            this.clearPartialData();
        }
    }

    hidePartialContainer() {
        if (this.inventoryService.selectedItem.packSize === 1 && this.showPartial === false) {
            this.hidePartial = true;
        } else if (this.inventoryService.selectedItem.packSize > 1 && this.showPartial === false) {
            this.hidePartial = false;
        }

        if (this.inventoryService.selectedItem.packSize === 1 && this.showPartial === true) {
            this.hidePartial = true;
            this.showPartial = false;
            this.partialStatus = true;
        } else if (this.inventoryService.selectedItem.packSize > 1 && this.showPartial === false && this.partialStatus === true) {
            this.hidePartial = false;
            this.showPartial = true;
            this.partialStatus = false;
        }
    }

    showAddItemContainer() {
        if (this.showAddItem === false && this.showPartial === true) {
            this.hidePartial = true;
            this.showPartial = false;
            this.partialStatus = true;
        }

        if (this.showAddItem === true && this.partialStatus === true) {
            this.hidePartial = false;
            this.showPartial = true;
            this.partialStatus = false;
        }

        this.showAddItem = !this.showAddItem;

        this.hidePartial = this.showAddItem === true;

        if (!this.showAddItem) {
            
        }
    }

    async openPartialBox(dialog: PartialdialogComponent) {
        this.dialogHelper.showPartialDialog(dialog, this.inventoryService.selectedItem).then((value) => {
            if (value !== null && value !== undefined) {
                this.replaceItems(this.inventoryService.selectedItem);
            }
        });
    }

    onItemSelected(args) {
        const listView = this._radListViewHelper.getListView(args);
        const itemArray = <InventoryDetails[]>listView.getSelectedItems();
        for (let i = 0; i < itemArray.length; i++) {
            if (this.inventoryService.selectedItem !== undefined) {
                if (this.inventoryService.selectedItem.customerItem !== itemArray[i].customerItem) {
                    this.inventoryService.selectedItem = itemArray[i];
                }
            }
            this.inventoryService.selectedItem = itemArray[i];
            this.clearPartialData();
            this.hidePartialContainer();
        }
    }

    public createFormGroupArrayInventory(dataItem: any) {
        return {
            'customerItemId': dataItem.customerItemId,
            'customerItem': dataItem.customerItem,
            'description': dataItem.description,
            'purchaseUOM': dataItem.purchaseUOM,
            'packSize': dataItem.packSize,
            'packUOM': dataItem.packUOM,
            'qty': dataItem.qty,
            'price': dataItem.price,
            'catchWeight': dataItem.catchWeight,
            'ledgerCode': dataItem.ledgerCode,
            'charges': dataItem.charges,
            'genericItem': dataItem.genericItem,
            'genericQty': dataItem.genericQty,
            'amount': dataItem.amount,
            'uomPackSize': dataItem.uomPackSize,
            'hasError': dataItem.hasError
        };
    }

    public replaceItems(invDetails: InventoryDetails) {
        if (invDetails === null || invDetails === undefined) {
            return;
        }
        this.inventoryService.updateItemData(invDetails);
        this.gridData.data.map((value) => {
            if (value.customerItem === invDetails.customerItem) {
                value.qty = +invDetails.qty;
                value.amount = value.qty * value.price;
            }
        });
        this.inventoryService.updateHeaderData();
    }

    public cellClickHandler({isEdited, dataItem, rowIndex}): void {
        let tempItem: any;
        if (this.kendoHelper.getFormGroup() !== null || this.kendoHelper.getFormGroup() !== undefined) {
            tempItem = this.kendoHelper.getFormGroup();
        }

        const result = this.kendoHelper.cellClickHandler({
            isEdited,
            dataItem,
            rowIndex
        }, this.createFormGroupArrayInventory(dataItem));
        if (result !== null) {

            console.log(tempItem);
            if (tempItem !== null && tempItem !== undefined) {
                this.replaceItems(tempItem.value);
            }

        }
    }

    async onSave() {

        // TODO if ftpRct = true call /fs-sourcelink-ws/rest/v1/receive/ftpreceipt?custId=26739&trackingId=49632530 instead of download
        this.inventoryService.processing = true;
        if (this.performCheck()) {
            await this.inventoryService.saveInventoryReceipt(this.inventoryService.inventoryDetails).then(async () => {
                    if (!this.deviceHelper.isAndroid() && !this.deviceHelper.isiOS()) {
                        if (this.applicationSettingsHelper.getFtpRct() === 'true') {
                            await this.inventoryService.getFtpReceipt(this.storeListService.pickedCustomerId, this.trackingId);
                        } else {
                            await this.inventoryService.getBohReceipt(this.storeListService.pickedCustomerId, this.trackingId);
                            const receipt = 'data:text/plain;base64,' + encodeBase64(this.inventoryService.bohReceipt);
                            saveAs(receipt, 'receipt.dat');
                        }
                    }
                    this.dialogHelper.showConfirmDialogOkOnly('Order Received ', 'Your Order has been saved').then(() => {
                        this.navigateHome();
                    });
                }
            ).catch((error) => {
                if (error != null && error.error != null) {
                    this.dialogHelper.showOkErrorDialog('Error', `${(error.error.message ? error.error.message : 'Problem saving receipt, Please Try Again')}`);
                } else {
                    this.dialogHelper.showOkErrorDialog('Error', `Problem saving receipt, Please Try Again`);
                }
                return;
            });
        }
        this.inventoryService.processing = false;
    }

    navigateHome() {
        this.router.navigateByUrl('home').then(r => r);
    }

    public onDocumentClick(e: any): void {
        if (this.kendoHelper === null || this.kendoHelper === undefined) {
            return;
        }
        if (this.kendoHelper._formGroup == null) {
            return;
        }
        if (this.kendoHelper._formGroup && this.kendoHelper._formGroup.valid &&
            !this.kendoHelper.matches(e.target, '#inventoryGrid tbody *, #inventoryGrid .k-grid-toolbar .k-button')) {
            const inventoryItems = this.kendoHelper._formGroup.value as InventoryDetails;
            this.replaceItems(inventoryItems);
            this.kendoHelper.saveCurrent(true);
        }
    }

    onListViewTextFocus(args, invDetails: InventoryDetails) {
        this.inventoryService.selectedItem = invDetails;
        this.clearPartialData();
    }

    onPartialQtyChanged(args) {
        const textField = this.textFieldHelper.getTextField(args);
        if (!textField.text.match('^(?:[0-9]\\d{0,5})?$')) {
            this.partialQtyError = true;
            textField.borderColor = 'red';
        } else {
            this.partialQtyError = false;
            textField.borderColor = 'black';
        }
    }

    onPartialQtyPress(args) {
        const textField = this.textFieldHelper.getTextField(args);
        if (this.partialQtyError) {
            return;
        } else {
            this.partialQtyInput = textField.text;
            this.partialQtyError = false;
            this.calculatePartial();
        }
        if (args.object.android) {
            args.object.android.clearFocus();
            textField.dismissSoftInput();
        }
    }

    onPartialQtyFocus() {
        this.partialQtyInput = '';
    }

    onPartialPackSizeChanged(args) {
        const textField = this.textFieldHelper.getTextField(args);
        if (!textField.text.match('^(?:[0-9]\\d{0,5})?$')) {
            this.partialPackSizeError = true;
            textField.borderColor = 'red';
        } else {
            this.partialPackSizeError = false;
            textField.borderColor = 'black';
        }
    }

    onSelectionChangeHandler($event: any) {
        this.inventoryService.selectedItem = $event.selectedRows[0].dataItem;
    }

    onPartialPackSizePress(args) {
        const textField = this.textFieldHelper.getTextField(args);
        if (this.partialPackSizeError) {
            return;
        } else {
            this.partialPackSizeInput = textField.text;
            this.partialPackSizeError = false;
            this.calculatePartial();
        }
        if (args.object.android) {
            args.object.android.clearFocus();
            textField.dismissSoftInput();
        }
    }

    onPartialPackSizeFocus() {
        this.partialPackSizeInput = '';
    }

    calculatePartial() {
        if (this.partialQtyInput === '') {
            this.partialQtyInput = this.inventoryService.selectedItem.qty.toString();
        }
        if (this.partialPackSizeInput === '') {
            this.partialPackSizeInput = this.inventoryService.selectedItem.packSize.toString();
        }
        this.partialCalcDecimal = '';
        this.partialCalcDecimal = (parseFloat(this.partialPackSizeInput) / this.inventoryService.selectedItem.packSize + parseFloat(this.partialQtyInput)).toFixed(2).toString();
    }

    onApply() {
        this.inventoryService.selectedItem.qty = +this.partialCalcDecimal;
        this.inventoryService.updateItemData(this.inventoryService.selectedItem);
    }

    clearPartialData() {
        this.partialQtyInput = '';
        this.partialPackSizeInput = '';
        this.partialCalcDecimal = '';
    }

    onReceiptChanged(args) {
        const textField = this.textFieldHelper.getTextField(args);
        this.totalReceiptError = !textField.text.match('^([1-9]|0)\\d{0,5}(?:\\.\\d{1,2})?$');
    }

    onReceiptPress(args) {
        const textField = this.textFieldHelper.getTextField(args);
        if (this.totalReceiptError) {
            return;
        } else {
            this.inventoryService.inventoryDetails.header.receiptTotal = textField.text;
            textField.text = '';
            this.totalReceiptError = false;
            this.inventoryService.updateHeaderData();
        }
    }

    onSalesTaxChanged(args) {
        const textField = this.textFieldHelper.getTextField(args);
        this.salesTaxError = !textField.text.match('^([1-9]|0)\\d{0,5}(?:\\.\\d{1,2})?$');
    }

    onSalesTaxPress(args) {
        const textField = this.textFieldHelper.getTextField(args);
        if (this.salesTaxError) {
            return;
        } else {
            this.inventoryService.inventoryDetails.header.salesTax = textField.text;
            textField.text = '';
            this.salesTaxError = false;
            this.inventoryService.updateHeaderData();
        }
    }

    onDiscountChanged(args) {
        const textField = this.textFieldHelper.getTextField(args);
        this.discountError = !textField.text.match('^([1-9]|0)\\d{0,5}(?:\\.\\d{1,2})?$');
    }

    onDiscountPress(args) {
        const textField = this.textFieldHelper.getTextField(args);
        if (this.discountError) {
            return;
        } else {
            this.inventoryService.inventoryDetails.header.discount = textField.text;
            textField.text = '';
            this.discountError = false;
            this.inventoryService.updateHeaderData();
        }
    }

    onSurchargeChanged(args) {
        const textField = this.textFieldHelper.getTextField(args);
        this.surchargeError = !textField.text.match('^([1-9]|0)\\d{0,5}(?:\\.\\d{1,2})?$');
    }

    onSurchargePress(args) {
        const textField = this.textFieldHelper.getTextField(args);
        if (this.surchargeError) {
            return;
        } else {
            this.inventoryService.inventoryDetails.header.surcharge = textField.text;
            textField.text = '';
            this.surchargeError = false;
            this.inventoryService.updateHeaderData();
        }
    }

    onQtyChanged(args) {
        const textField = this.textFieldHelper.getTextField(args);
        if (!textField.text.match('^[0-9]{0,3}$')) {
            textField.borderColor = 'red';
            this.inventoryService.selectedItem.hasError = true;
        } else {
            textField.borderColor = 'black';
            this.inventoryService.selectedItem.hasError = false;
        }
    }

    onQtyReturnPress(args) {
        const textField = this.textFieldHelper.getTextField(args);
        if (!this.inventoryService.selectedItem.hasError) {
            this.inventoryService.selectedItem.qty = textField.text;
            this.inventoryService.updateItemData(this.inventoryService.selectedItem);
            this.inventoryService.updateHeaderData();
        }
    }

    onCostChanged(args) {
        const textField = this.textFieldHelper.getTextField(args);
        if (!textField.text.match('^[1-9]\\d{0,5}(?:\\.\\d{1,2})?$')) {
            textField.borderColor = 'red';
            this.inventoryService.selectedItem.hasError = true;
        } else {
            textField.borderColor = 'black';
            this.inventoryService.selectedItem.hasError = false;
        }
    }

    onCostReturnPress(args) {
        const textField = this.textFieldHelper.getTextField(args);
        if (!this.inventoryService.selectedItem.hasError) {
            this.inventoryService.selectedItem.price = textField.text;
            this.inventoryService.updateItemData(this.inventoryService.selectedItem);
        }
    }

    async openAllItemsDialog() {
        await this.dialogHelper.showInventoryAddItems().then((value) => {
            this.replaceItems(value);
        });
    }

    onInventoryGridpageChange($event: any) {
        console.log($event);
    }

    onInventoryGriddataStateChange($event: any) {
        this.state = $event;
        this.gridData = this.kendoHelper.processItemsAndReturn(this.inventoryService.inventoryDetails.details, this.state);
    }

    onInputChange() {
        try {
            this.inventoryService.updateHeaderData();
        } catch (exception) {
            this.dialogHelper.showOkErrorDialog('Error', `Problem updating values. Please make sure the value is 0 or greater`);
        }

    }

    onContextSelect({dataItem, item}) {
        if (item === 'Delete Item') {
            const selectedIndex = this.inventoryService.inventoryDetails.details.indexOf(dataItem);
            this.inventoryService.inventoryDetails.details.splice(selectedIndex, 1);
            this.inventoryService.updateHeaderData();
        }
    }

    performCheck() {
        this.inventoryService.updateHeaderData();
        if (this.inventoryService.compDiff !== 0) {
            this.dialogHelper.showOkErrorDialog('Error', 'Cannot save receipt until it is balanced.').then(resp => {
                if (resp) {
                    return false;
                }
            });
        } else {
            return true;
        }
    }

    onCancel() {
        this.navigateHome();
    }

    deleteItem() {
        this.dialogHelper.showConfirmDialogYesNo(Nomenclatures.DIALOG_DELETE_INVENTORY_ITEM, 'Delete this item?').then((result) => {
            if (!result) {
                return
            }
            this.inventoryService.onDeleteItem();
        })

    }

    ngOnDestroy(): void {
        this.applicationSettingsHelper.setEvent('');
        this.applicationSettingsHelper.setTrackingId('');
    }
}
